(function () {
  function initEmbla(root) {
    if (!root || root.__emblaInitialized) return;

    const viewport = root.querySelector('.embla__viewport');
    if (!viewport || typeof EmblaCarousel !== 'function') return;

    const dotsRoot        = root.querySelector('.embla__dots');
    const loop            = (root.dataset.loop || 'true') === 'true';
    const draggable       = (root.dataset.draggable || 'true') === 'true';
    const autoplayEnabled = (root.dataset.autoplay || 'false') === 'true';
    const autoplayDelay   = Number(root.dataset.autoplayDelay || 4000);
    const prefersReduced  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let autoplayPlugin;
    if (autoplayEnabled && !prefersReduced && typeof EmblaCarouselAutoplay === 'function') {
      autoplayPlugin = EmblaCarouselAutoplay({
        delay: autoplayDelay,
        stopOnInteraction: true
      });
    }

    const embla = EmblaCarousel(
      viewport,
      {
        loop,
        draggable,
        align: 'start',
        containScroll: 'trimSnaps',
        slidesToScroll: 1
      },
      autoplayPlugin ? [autoplayPlugin] : []
    );

    // Hover pause/resume (pass embla!)
    if (autoplayPlugin) {
      root.addEventListener('mouseenter', () => autoplayPlugin.stop(embla));
      root.addEventListener('mouseleave', () => autoplayPlugin.play(embla));
    }

    // ----- Dots -----
    let dots = [];

    function setupDots() {
      if (!dotsRoot) return;
      dotsRoot.innerHTML = '';

      // Create one dot per "snap" (slide position)
      embla.scrollSnapList().forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'embla__dot';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => embla.scrollTo(index));
        dotsRoot.appendChild(dot);
        dots.push(dot);
      });
    }

    function updateDots() {
      if (!dotsRoot || !dots.length) return;
      const selected = embla.selectedScrollSnap();
      dots.forEach((dot, i) => {
        const active = i === selected;
        dot.classList.toggle('is-selected', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    setupDots();
    updateDots();

    // Keep dots in sync when Embla changes state
    embla.on('select', updateDots);
    embla.on('reInit', () => { setupDots(); updateDots(); });

    root.__emblaInitialized = true;
    console.log('Embla initialized:', root);
  }



  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.embla').forEach(initEmbla);
  });
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.embla');
    if (root) initEmbla(root);
  });
})();